import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import HrbTranslate from '../language/HrbTranslate';
import BackLink from '../library/common/BackLink';
import Skeleton from '../library/loaders/Skeleton';

const ErrorContent = (props) => {
    const { errorTitleKey, errorDetailKey } = props;
    
    return (
        <Fragment>
            <div className='columns level'>                
                <div className='column is-8 is-offset-1'>
                    {errorTitleKey &&
                        <h1><HrbTranslate text={errorTitleKey} /></h1>
                    }
                    {!errorTitleKey &&
                        <Skeleton />
                    }
                </div>
                <div className='column is-2'>
                    <BackLink isRight />
                </div>
                <div className='column is-1' />
            </div>
            <div className='columns level'>
                <div className='column is-10 is-offset-1'>
                    <hr className='my-0'/>
                </div>
            </div>
            <div className='columns level'>
                <div className='column is-offset-1 is-10'>
                    {errorDetailKey &&
                        <HrbTranslate text={errorDetailKey} />
                    }
                </div>
            </div>
        </Fragment>
    );
}

ErrorContent.whyDidYouRender = false;

ErrorContent.propTypes = {
    errorTitleKey: PropTypes.string,
    errorDetailKey: PropTypes.string
}

export default ErrorContent